<template>
    <ol-vector-layer :zIndex="500" updateWhileInteracting >

        <ol-source-vector :features="features">
            <!-- <ol-style :overrideStyleFunction="overrideStyleFunction">
            </ol-style>
            -->
                <vector-styles :selected="false" />
        </ol-source-vector>

    </ol-vector-layer>
</template>



<script setup>


import { computed, onMounted } from 'vue'

import VectorStyles from  "@/components/map/layers/VectorStyles.vue"
// https://openlayers.org/en/latest/apidoc/module-ol_style_Style-Style.html

import GeoJSON from 'ol/format/GeoJSON.js';

import { useDataStore } from "@/store/data";




const layer = defineModel("layer")


const dataStore = useDataStore();




const features = computed(() => {

    // console.log("🌍 "+layer.value.name + " layer computed features!")
    // console.log(layer.value)
    
    
    // console.log(dataStore.allVisibleFeaturesGeoJson)



    const features = new GeoJSON().readFeatures(dataStore.allVisibleFeaturesGeoJson, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3857",
    })
    // console.log(features)
    return features
})





onMounted(() => {
    console.log("🌍 GlobalGatherLayer layer mounted!")
})




</script>
